import { useMemo } from 'react';
import { getProfile } from './authService';

/**
 * The signed-in user's profile, read per component rather than per module.
 *
 * Several components used to do `const storedUser = JSON.parse(localStorage
 * .getItem('profile'))` at module scope. That evaluates once, the first time the
 * bundle imports the file, so role-derived flags kept the value from whoever was
 * signed in then — signing in as a different role left the old permissions in
 * place until a hard reload. Reading it in the component ties it to the mount.
 */
export default function useProfile() {
  return useMemo(() => getProfile() || {}, []);
}

/** True when the profile's role is one of `roles`. */
export function useHasRole(...roles) {
  const profile = useProfile();
  return Boolean(profile?.role && roles.flat().includes(profile.role));
}
